import User from "@/api/User";
import UserEmailAddress from "@/api/UserEmailAddress";
import UserAddress from "@/api/UserAddress";
import UserPhoneNumber from "@/api/UserPhoneNumber"
import UserExternalLink from "@/api/UserExternalLink"
import Application from "@/api/Application";
import Company from "@/api/Company";
import CompanyType from "../CompanyType";
import CompanyGroup from "../CompanyGroup";
import CompanyAddress from "../CompanyAddress";
import CompanyAddressPhoneNumber from "../CompanyAddressPhoneNumber";
import CompanyEmailAddress from "../CompanyEmailAddress";
import CompanyExternalLink from "../CompanyExternalLink";
import CompanyToba from "../CompanyToba";
import Role from "@/api/Role";
import Audit from "@/api/Audit";
import ExternalWebservice from "../ExternalWebservice";
import Log from "@/api/Log";
import LandingPagePersona from "@/api/Persona/LandingPage";
import FulwebPersona from "@/api/Persona/Fulweb";
import LearnDashPersona from "@/api/Persona/LearnDash";
import OrionPersona from "@/api/Persona/Orion";
import DataCentrePersona from "@/api/Persona/DataCentre";
import IprPlatformPersona from "@/api/Persona/IprPlatform";
import SyncUser from "@/api/Sync/SyncUser";
import SyncRole from "@/api/Sync/SyncRole";
import Report from "@/api/Report";
import UserLearningType from "@/api/UserLearningType";
import UserProfile from "@/api/UserProfile";
import RiskCode from "@/api/RiskCode";
import RiskCodeReference from "@/api/RiskCodeReference";
import ClientMap from "@/api/ClientMap";
import Product from "@/api/Product";
import ProductBundle from "@/api/ProductBundle";
import MappingRenewal from "@/api/MappingRenewal";
import CommercialProduct from "@/api/CommercialProduct";
import CommercialClaim from "@/api/ClaimsNotifications/CommercialClaim";
import CommercialClaimIpr from "@/api/ClaimsNotificationsIpr/CommercialClaimIpr";
import DynamicClaim from "@/api/ClaimsNotifications/Dynamic";
import DynamicClaimIpr from "@/api/ClaimsNotificationsIpr/DynamicIpr";
import StandardClause from "@/api/Product/StandardClause";
import Wording from "@/api/Product/Wording";
import FrontJacket from "@/api/Product/FrontJacket";
import RearJacket from "@/api/Product/RearJacket";
import LloydsRiskCode from "@/api/Product/LloydsRiskCode";
import LIORiskCode from "@/api/Product/LIORiskCode";
import InsuranceType from "@/api/Product/InsuranceType";
import ProductCategory from "@/api/Product/ProductCategory";
import Dynamic from "@/api/Product/Dynamic";
import Facility from "@/api/Facility";
import ClassOfBusiness from "@/api/Facility/ClassOfBusiness";
import Territory from "@/api/Facility/Territory";
import FacilityType from "@/api/Facility/FacilityType";
import ClassOfRisk from '@/api/Facility/ClassOfRisk';
import SectionClassificationType from '@/api/Facility/SectionClassificationType';
import InsurerRole from '@/api/Facility/InsurerRole';
import Administrators from "@/api/ContentManagement/Administrators";
import News from "@/api/ContentManagement/News";
import Nodes from "@/api/ContentManagement/Nodes";
import ProducerCommercialProductIpr from "@/api/CommercialProductIpr/Producer";
import CoverholderCommercialProductIpr from "@/api/CommercialProductIpr/Coverholder";
import CoverholderProductIpr from "@/api/ProductIpr/Coverholder/Product";
import CoverholderStandardClauseIpr from "@/api/ProductIpr/Coverholder/StandardClause";
import CoverholderWordingIpr from "@/api/ProductIpr/Coverholder/Wording";
import CoverholderFrontJacketIpr from "@/api/ProductIpr/Coverholder/FrontJacket";
import CoverholderRearJacketIpr from "@/api/ProductIpr/Coverholder/RearJacket";
import CoverholderLloydsRiskCodeIpr from "@/api/ProductIpr/Coverholder/LloydsRiskCode";
import CoverholderLIORiskCodeIpr from "@/api/ProductIpr/Coverholder/LIORiskCode";
import CoverholderInsuranceTypeIpr from "@/api/ProductIpr/Coverholder/InsuranceType";
import CoverholderProductCategoryIpr from "@/api/ProductIpr/Coverholder/ProductCategory";
import CoverholderDynamicIpr from "@/api/ProductIpr/Coverholder/Dynamic";
import ProducerProductIpr from "@/api/ProductIpr/Producer/Product";
import ProducerStandardClauseIpr from "@/api/ProductIpr/Producer/StandardClause";
import ProducerWordingIpr from "@/api/ProductIpr/Producer/Wording";
import ProducerFrontJacketIpr from "@/api/ProductIpr/Producer/FrontJacket";
import ProducerRearJacketIpr from "@/api/ProductIpr/Producer/RearJacket";
import ProducerLloydsRiskCodeIpr from "@/api/ProductIpr/Producer/LloydsRiskCode";
import ProducerLIORiskCodeIpr from "@/api/ProductIpr/Producer/LIORiskCode";
import ProducerInsuranceTypeIpr from "@/api/ProductIpr/Producer/InsuranceType";
import ProducerProductCategoryIpr from "@/api/ProductIpr/Producer/ProductCategory";
import ProducerDynamicIpr from "@/api/ProductIpr/Producer/Dynamic";

import Auth from "../Auth";

class Manager {
  constructor() {
    this.users = User;
    this.userAddress = UserAddress;
    this.userEmailAddress = UserEmailAddress;
    this.userPhoneNumber = UserPhoneNumber;
    this.userLearningType = UserLearningType;
    this.userProfile = UserProfile;
    this.userExternalLink = UserExternalLink;
    this.companies = Company;
    this.companyTypes = CompanyType;
    this.companyGroups = CompanyGroup
    this.companyAddress = CompanyAddress;
    this.companyAddressPhoneNumber = CompanyAddressPhoneNumber;
    this.companyEmailAddress = CompanyEmailAddress;
    this.companyExternalLink = CompanyExternalLink;
    this.companyToba = CompanyToba;
    this.roles = Role;
    this.applications = Application;
    this.roles = Role;
    this.fulwebPersonas = FulwebPersona;
    this.learnDashPersonas = LearnDashPersona;
    this.landingPagePersonas = LandingPagePersona;
    this.orionPersonas = OrionPersona;
    this.dataCentrePersonas = DataCentrePersona;
    this.iprPlatformPersonas = IprPlatformPersona;
    this.externalWebservices = ExternalWebservice;
    this.logs = Log;
    this.audits = Audit;
    this.sync = {
      users: SyncUser,
      roles: SyncRole,
    }
    this.reports = Report;
    this.riskCode = RiskCode;
    this.riskCodeReference = RiskCodeReference;
    this.clientMap = ClientMap;
    this.products = Product;
    this.mappingRenewals = MappingRenewal;
    this.productBundles = ProductBundle;
    this.commercialProducts = CommercialProduct;
    this.commercialClaims = CommercialClaim;
    this.dynamicClaims = DynamicClaim;
    this.commercialClaimsIpr = CommercialClaimIpr;
    this.dynamicClaimsIpr = DynamicClaimIpr;
    this.productWording = Wording;
    this.productStandardClause = StandardClause;
    this.productFrontJacket = FrontJacket;
    this.productRearJacket = RearJacket;
    this.productLloydsRiskCode = LloydsRiskCode;
    this.productLIORiskCode = LIORiskCode;
    this.productInsuranceType = InsuranceType;
    this.productCategory = ProductCategory;
    this.productDynamic = Dynamic;

    this.producerCommercialProductsIpr = ProducerCommercialProductIpr;
    this.coverholderCommercialProductsIpr = CoverholderCommercialProductIpr;

    this.coverholderProductsIpr = CoverholderProductIpr
    this.coverholderProductWordingIpr = CoverholderWordingIpr
    this.coverholderProductStandardClauseIpr = CoverholderStandardClauseIpr
    this.coverholderProductFrontJacketIpr = CoverholderFrontJacketIpr
    this.coverholderProductRearJacketIpr = CoverholderRearJacketIpr
    this.coverholderProductLloydsRiskCodeIpr = CoverholderLloydsRiskCodeIpr
    this.coverholderProductLIORiskCodeIpr = CoverholderLIORiskCodeIpr
    this.coverholderProductInsuranceTypeIpr = CoverholderInsuranceTypeIpr
    this.coverholderProductCategoryIpr = CoverholderProductCategoryIpr
    this.coverholderProductDynamicIpr = CoverholderDynamicIpr

    this.producerProductsIpr = ProducerProductIpr
    this.producerProductWordingIpr = ProducerWordingIpr
    this.producerProductStandardClauseIpr = ProducerStandardClauseIpr
    this.producerProductFrontJacketIpr = ProducerFrontJacketIpr
    this.producerProductRearJacketIpr = ProducerRearJacketIpr
    this.producerProductLloydsRiskCodeIpr = ProducerLloydsRiskCodeIpr
    this.producerProductLIORiskCodeIpr = ProducerLIORiskCodeIpr
    this.producerProductInsuranceTypeIpr = ProducerInsuranceTypeIpr
    this.producerProductCategoryIpr = ProducerProductCategoryIpr
    this.producerProductDynamicIpr = ProducerDynamicIpr

    this.facilities = Facility;
    this.facilityClassOfBusiness = ClassOfBusiness;
    this.facilityClassOfRisk = ClassOfRisk;
    this.facilitySectionClassificationType = SectionClassificationType;
    this.facilityTerritory = Territory;
    this.facilityType = FacilityType;
    this.facilityInsurerRole = InsurerRole;

    this.contentManagementAdministrators = Administrators;
    this.contentManagementNews = News;
    this.contentManagementNodes = Nodes;
    this.auth = Auth;
  }
}

export default Manager;
